import format from 'date-fns/format'

const DOB_FORMAT = 'yyyy-MM-dd'

/**
 * Format the 'dob' to the expected date format
 * @param dob{Date}
 * @returns {string}
 */
export function formatDob(dob) {
  return format(dob, DOB_FORMAT)
}
